import request from '@/utils/request'

// 查询保证金明细列表
export function listShopDepositRecord(query) {
  return request({
    url: '/shop/deposit/record/list',
    method: 'get',
    params: query
  })
}

// 查询保证金明细分页
export function pageShopDepositRecord(query) {
  return request({
    url: '/shop/deposit/record/page',
    method: 'get',
    params: query
  })
}

// 查询保证金明细详情
export function getShopDepositRecord(id) {
  return request({
    url: '/shop/deposit/record/info',
    method: 'get',
    params: { id }
  })
}

// 审核保证金明细
export function auditShopDepositRecord(data) {
  return request({
    url: '/shop/deposit/record/audit',
    method: 'post',
    data: data
  })
}

// 删除保证金明细
export function delShopDepositRecord(ids) {
  return request({
    url: '/shop/deposit/record/delete',
    method: 'post',
    data: ids
  })
}
